/**
 *  Created by piotr@revisual.io on 18/08/2025
 */

export const dateTimeFormatter = new Intl.DateTimeFormat(
  window.navigator.language || "en-US",
  {
    year: "numeric",
    month: "numeric",
    day: "numeric",
  }
);
